// ETRS89 / UTM zone 32N (EPSG:25832) -> WGS84 (lon/lat i grader).
// Krüger-række for omvendt Transverse Mercator med GRS80-ellipsoiden.
// Skrevet selv for at undgå en ekstra afhængighed (proj4) i et gammelt build.
const A = 6378137;
const F = 1 / 298.257222101;
const K0 = 0.9996;
const FALSE_EASTING = 500000;
const LON0 = (9 * Math.PI) / 180;

const n = F / (2 - F);
const n2 = n * n;
const n3 = n2 * n;
const n4 = n3 * n;
const AA = (A / (1 + n)) * (1 + n2 / 4 + n4 / 64);

const beta = [
  n / 2 - (2 * n2) / 3 + (37 * n3) / 96 - n4 / 360,
  n2 / 48 + n3 / 15 - (437 * n4) / 1440,
  (17 * n3) / 480 - (37 * n4) / 840,
  (4397 * n4) / 161280,
];
const delta = [
  2 * n - (2 * n2) / 3 - 2 * n3 + (116 * n4) / 45,
  (7 * n2) / 3 - (8 * n3) / 5 - (227 * n4) / 45,
  (56 * n3) / 15 - (136 * n4) / 35,
  (4279 * n4) / 630,
];

export function utm32ToWgs84(easting, northing) {
  const xiP = northing / (K0 * AA);
  const etaP = (easting - FALSE_EASTING) / (K0 * AA);

  let xi = xiP;
  let eta = etaP;
  for (let j = 1; j <= 4; j++) {
    xi -= beta[j - 1] * Math.sin(2 * j * xiP) * Math.cosh(2 * j * etaP);
    eta -= beta[j - 1] * Math.cos(2 * j * xiP) * Math.sinh(2 * j * etaP);
  }

  const chi = Math.asin(Math.sin(xi) / Math.cosh(eta));
  let lat = chi;
  for (let j = 1; j <= 4; j++) {
    lat += delta[j - 1] * Math.sin(2 * j * chi);
  }
  const lon = LON0 + Math.atan(Math.sinh(eta) / Math.cos(xi));

  return { lon: (lon * 180) / Math.PI, lat: (lat * 180) / Math.PI };
}
